import { HOUR_IN_MILLIS, MINUTE_IN_MILLIS } from "./times";

/* 

  Caching 

  ReactQuery gcTime is in milliseconds!

*/

export const CACHE_CATEGORYPRODUCTSCOUNT_MILLIS = MINUTE_IN_MILLIS * 3;
export const CACHE_ALLPAGES = HOUR_IN_MILLIS * 2;
export const CACHE_PRODUCTOFFERS_MILLIS = HOUR_IN_MILLIS * 12;
export const CACHE_PRODUCTDOCS_MILLIS = HOUR_IN_MILLIS * 12;
export const CACHE_PRODUCTIMAGE = HOUR_IN_MILLIS * 12;
export const CACHE_FAQ = HOUR_IN_MILLIS * 12;

// PDP: clear product cache tag on user demand
// see route /api/product/[id]/route.ts
export const PDP_CLEAR_CACHE_SECRET = "LeM9TYAN";
